import { calculatePayroll } from "./payroll";
import { calculateLitigation, calculateSeparation } from "./separation";
import { calculateRealEstateIsr } from "./real-estate-isr";
import type { CalculatorInput, CalculationResult } from "./types";

export * from "./types";
export * from "./parameters";
export * from "./payroll";
export * from "./separation";
export * from "./tax";
export * from "./fiscal-indicators";
export * from "./real-estate-isr";

export function calculate(input: CalculatorInput): CalculationResult {
  switch (input.kind) {
    case "payroll":
      return calculatePayroll(input);
    case "finiquito":
    case "liquidation":
      return calculateSeparation(input);
    case "litigation":
      return calculateLitigation(input);
    case "real-estate-isr":
      return calculateRealEstateIsr(input);
    default: {
      const exhaustive: never = input;
      throw new Error(`Tipo de cálculo no soportado: ${String(exhaustive)}`);
    }
  }
}
